export default {
  brand: {
    primary: '#008542',
    secondary: '#0c509f',
    tertiary: '#007138',
    quaternary: '#000000',
  },
};
